<template>
  <div class="min-h-screen overflow-y-auto overflow-x-hidden text-slate-200">
    <HeaderView v-if="!$route.meta.hideHeader" />
    <router-view />
  </div>
</template>
<script>
import HeaderView from './components/HeaderView.vue';
import axios from 'axios';
export default {
  components: {
    HeaderView,
  },
  async mounted() {
    let token = localStorage.getItem('token');
    if (token) {
      await axios
        .post(
          `${process.env.VUE_APP_API_URL || 'http://localhost:3000'}/auth/users`,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          // console.log(res);
          this.$store.commit('setUsers', res.data.user);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            localStorage.removeItem('token');
          }
        });
    }
  },
};
</script>
<style>
#app {
  /* overflow: hidden; */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  max-width: 100vw;
  min-height: 100vh;
  background: #080f1a;
}
</style>
